import { createMiddleware } from '@shared/redux';
import { getBillingDetailsRequest } from '@domain/billing/details';
import { getStripeCustomerRequest } from '@domain/billing/stripe/stripe-customer';
import { showErrorToast } from '@shared/toasts';
import {
    getStep,
    changeNewCampaignModalStep,
    OPEN_NEW_CAMPAIGN_MODAL,
    CHANGE_NEW_CAMPAIGN_MODAL_STEP,
} from '../interface/interface.state';
import {
    CREATE_CAMPAIGN_REQUEST_FAILED,
    CREATE_CAMPAIGN_REQUEST_SUCCEEDED,
    GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED,
    REEVALUATE_AD_DURATION,
    getDraftMobeesCampaign,
    UPDATE_CAMPAIGN_REQUEST_FAILED,
    UPDATE_CAMPAIGN_REQUEST_SUCCEEDED,
} from './campaign.state';
import { getAds, loadAds, updateAds } from '../ads/ad.state';

export const campaignMiddleware = createMiddleware({
    [OPEN_NEW_CAMPAIGN_MODAL]: (state) => {
        const firstStep = 1;
        const activeStep = getStep(state);

        if (firstStep === activeStep) {
            return getDraftMobeesCampaign();
        }

        return [];
    },
    [CHANGE_NEW_CAMPAIGN_MODAL_STEP]: (_, action) => {
        const nextStep = action.payload.step;
        const paymentStep = 3;

        if (nextStep === paymentStep) {
            return [
                getStripeCustomerRequest(),
                getBillingDetailsRequest(),
            ];
        }

        return [];
    },
    [CREATE_CAMPAIGN_REQUEST_SUCCEEDED]: () => [changeNewCampaignModalStep(2)],
    [UPDATE_CAMPAIGN_REQUEST_SUCCEEDED]: () => [changeNewCampaignModalStep(2)],
    [CREATE_CAMPAIGN_REQUEST_FAILED]: () => [
        showErrorToast({
            message: 'There was an error creating your campaign. Try again in a few minutes.',
        }),
    ],
    [UPDATE_CAMPAIGN_REQUEST_FAILED]: () => [
        showErrorToast({
            message: 'There was an error creating your campaign. Try again in a few minutes.',
        }),
    ],
    [GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED]: (_, action) => {
        const draftCampaign = action.payload.data[0];

        if (draftCampaign?.ads.length) {
            return loadAds(draftCampaign.ads);
        }

        return [];
    },
    [REEVALUATE_AD_DURATION]: (state, action) => {
        const ads = getAds(state);
        const { startDate, endDate } = action.payload;

        const newAds = ads.map((ad) => {
            const invalidStartDate = ad.data.startDate < startDate;
            const invalidEndDate = ad.data.endDate > endDate;
            return invalidStartDate || invalidEndDate
                ? { ...ad, isCompleted: false } : ad;
        });

        return [updateAds(newAds)];
    },
});
